<template>
	<div class="xbd-tabs">
		<div
			v-for="item in tabs"
			:key="item.value"
			:ref="`tab-${item.value}`"
			class="xbd-tabs__tab"
			:class="{
				active: value === item.value,
				disabled: item.disabled
			}"
			v-permission="item.permissions"
			@click="handleTabClick(item)"
		>
			<template v-if="!hasTabSlot">{{ item.label }}</template>
			<slot v-else :tab="item"></slot>
		</div>

		<div
			class="xbd-tabs__bar"
			:style="{
				width: `${barWidth}px`,
				transform: `translateX(${barOffsetLeft}px)`
			}"
		></div>
	</div>
</template>

<script>
/**
 * @description 自定义Tabs组件
 * @param {Number|String} value - 当前选中的tab的value
 * @param {Array} tabs - tab列表
 * @param {String} tabs[].label - tab名称
 * @param {Number|String} tabs[].value - tab值
 * @param {Boolean} tabs[].disabled - 是否禁用
 * @param {String|Array} tabs[].permissions - 权限
 *
 * @event {Function} change - tab切换时触发
 */

export default {
	name: "XbdTabs",
	props: {
		value: {
			type: [Number, String],
			default: ""
		},
		tabs: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			barWidth: 0,
			barOffsetLeft: 0
		};
	},
	computed: {
		hasTabSlot() {
			return Boolean(this.$slots["default"]) || Boolean(this.$scopedSlots["default"]);
		}
	},
	methods: {
		handleTabClick(tab) {
			if (tab.disabled) {
				return;
			}

			this.$emit("input", tab.value);
			this.$emit("change", tab.value, tab);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val) {
				this.$nextTick(() => {
					if (this.tabs.length > 0 && val !== "") {
						const currentTabRef = this.$refs[`tab-${this.value}`][0];

						if (currentTabRef) {
							this.barWidth = currentTabRef.offsetWidth;
							this.barOffsetLeft = currentTabRef.offsetLeft;
						}
					}
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.xbd-tabs {
	width: 100%;
	height: 48px;
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;

	&__tab {
		color: #74798a;
		text-align: center;
		font-family: "PingFang SC";
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px;
		cursor: pointer;

		&:hover {
			color: $primary-color;
		}

		&.active {
			color: $primary-color;
			font-weight: 500;
		}

		&.disabled {
			color: #dcdde1;
			cursor: not-allowed;
		}

		&:not(:first-child) {
			margin-left: 24px;
		}
	}

	&__bar {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 3px;
		background-color: $primary-color;
		z-index: 1;
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		list-style: none;
	}
}
</style>
